import Com from "components/styledComp/CommStyledComp";
import React from "react";

const SpdstSeb = () => {
    return(
        <Com.DivDetailSection3 border={"false"}>
            <Com.DivDetailHeading>
                <Com.DetailHeading>sPedestal</Com.DetailHeading>
                <Com.DetailHeadingP>에스페데스탈</Com.DetailHeadingP>
                <Com.DivDetailHeading>
                    <div className="paragraph">
                    sDevice 가 장착되어 전기/수도/조명을 원격 제어및 검침할 수 있는 국산 페데스탈
                    </div>
                </Com.DivDetailHeading>
            </Com.DivDetailHeading>
            <div className="strategy">
                <Com.StrongStrategy>sPedestal의 특징</Com.StrongStrategy>
            </div>
            <div className="pedestal-descbox">
                <div className="pedestal-parabox-seb">
                    <ul>
                        <li>sDevice의 원격 제어 검침 구현</li>
                        <li>동절기의 손쉬운 수도 드레인</li>
                        <li>마리나 시설 관리 시스템(Marina Facility Management System)과 연계</li>
                    </ul>
                </div>
            </div>
        </Com.DivDetailSection3>
    );
}

export default SpdstSeb;